import { useEffect } from "react";
import { ensureNeuroIDBootstrapScript, identifyApplication } from "@lending/lib/neuroid";
import { Institution } from "@lending/types";
import { useStore } from "../contexts/StoreContext";

function useLoadNeuroID(institution: Institution) {
  const siteId = institution.lending_neuro_id_site_id;
  const { data } = useStore();
  const applicationUuid = data.lendingApplicationID ?? "";

  useEffect(() => {
    if (!siteId) {
      return;
    }
    ensureNeuroIDBootstrapScript(siteId);
  }, [siteId]);

  useEffect(() => {
    if (!siteId || !applicationUuid) {
      return;
    }
    identifyApplication(applicationUuid);
  }, [siteId, applicationUuid]);
}

export { useLoadNeuroID };
